import * as React from 'react';
import { useTranslation, Trans } from 'next-i18next';

import Select from '../Select';

type WindowModeType = 'fullscreen' | 'windowed';

export default function WindowSettings() {
  const [windowMode, setWindowMode] = React.useState('fullscreen');
  const { t } = useTranslation();

  const handleChangeMode = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const mode = event.target.value as WindowModeType;
    setWindowMode(mode);
    localStorage.setItem('windowMode', mode);
    window.electronAPI.changeWindowMode(mode);
  };

  React.useEffect(() => {
    // 実際のモードはElectron側が保持している（F11/Alt+Enterや起動オプションでも変わるため）
    if (window.electronAPI?.getWindowMode) {
      window.electronAPI.getWindowMode().then((mode) => {
        setWindowMode(mode);
        localStorage.setItem('windowMode', mode);
      });
      return;
    }

    // 古いクライアントは起動時に必ずフルスクリーンになる
    setWindowMode('fullscreen');
    localStorage.setItem('windowMode', 'fullscreen');
  }, []);

  return (
    <div className="max-w-[200px]">
      <Select
        className="text-base"
        value={windowMode}
        onChange={handleChangeMode}
      >
        <option className="text-black" value="fullscreen">
          {t('options.window.fullScreen')}
        </option>
        <option className="text-black" value="windowed">
          {t('options.window.windowed')}
        </option>
      </Select>
    </div>
  );
}
